import MediaQuery from 'react-responsive'

import { GRID_BREAKPOINT_MD } from 'shared/breakpoints'
import { brandLogosSelector, landingPageRouteSelector } from 'wordpress/selectors'
import NavLeft from './NavLeft'
import NavRight from './NavRight'
import NavRightResponsive from './NavRightResponsive'
import NavSearch from './NavSearch'

import logo from 'shared/icons/ic-logo.svg'

const $Brand = ({ brandLogos, landingPageRoute }) => (
    <Link to={landingPageRoute ? landingPageRoute.slug : '/'} className="nav-indigo-brand">
        <img className="nav-indigo-logo" alt="Indigo" src={brandLogos?.navbarLogo || logo} />
    </Link>
)
const Brand = compose(
    connect(
        createStructuredSelector({
            brandLogos: brandLogosSelector,
            landingPageRoute: landingPageRouteSelector,
        })
    ),
    withTranslate
)($Brand)

const NavBar = ({ isSearch }) => (
    <div className="indigo-nav-container" id="indigo-nav">
        <div className="indigo-nav">
            <nav className="container">
                <Brand />
                <div className="indigo-nav-search-container">
                    {!isSearch && <NavLeft />}
                    {isSearch && <NavSearch />}
                </div>
                <MediaQuery minWidth={GRID_BREAKPOINT_MD}>
                    <NavRight />
                </MediaQuery>
                <MediaQuery maxWidth={GRID_BREAKPOINT_MD - 1}>
                    <NavRightResponsive />
                </MediaQuery>
            </nav>
        </div>
    </div>
)

NavBar.propTypes = {
    isSearch: PropTypes.bool.isRequired,
}

export default NavBar
